import Vue from 'vue'
import { EventBus } from '@/services/EventBus'

export default {
    name: 'Dropdown',
    data () {
        return {
            show: this.open,
            positions: this.type,
        }
    },
    props: {
        type: {
            type: String,
            default: 'right'
        },
        isSelect: {
            type: Boolean,
            default: false,
        },
        container: {
            default: null
        },
        open: {
            type: Boolean,
            default: false,
        },
        closeOther: {
            type: Boolean,
            default: true,
        }
    },
    created() {
        if (this.isSelect)
            this.$parent.$on('select:open', () => {
                this.calculate()
            })

        this.$parent.$on('select:close', () => {
            this.show = false
            this.$emit('update:open', false)
        })
    },
    watch: {
        open(value) {
            this.show = value
        }
    },
    mounted() {
        EventBus.$on('root-click', () => {
            this.show = false
            this.$emit('update:open', false)
        })

        EventBus.$on('dropdown:open', (target) => {
            if (this.$el != target && this.show) {
                this.show = false
                this.$emit('update:open', false)
            }
        })
    },
    methods:  {
        toggle(event) {
            if ( ! this.show && this.closeOther)
                EventBus.$emit('dropdown:open', event.target)

            this.show = ! this.show
            this.$emit('update:open', this.show)

            if (this.show) {
                if (this.container) {
                    this.$nextTick(() => {
                        if ( ! this.isSelect)
                            this.calculate()

                        this.$emit('open')
                    })
                } else
                    this.$emit('open')
            }
        },
        calculate() {
            let containerRects = this.container.getBoundingClientRect()
            let toggleRects = this.$refs.toggle.getBoundingClientRect()
            let listRects = this.$refs.list.getBoundingClientRect()
            let align = containerRects.right - listRects.right < 0 ? 'right' : 'left'
            let valign = containerRects.bottom - (toggleRects.bottom + listRects.height) < 0 ? 'bottom' : 'right'
            this.positions = align + ' ' + valign
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/dropdown/dropdown.js